"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var trackSegmentEvent = function trackSegmentEvent(event) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (window && window.analytics && window.analytics.track) {
    window.analytics.track(event, properties);
  }
};

exports.default = trackSegmentEvent;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/trackSegmentEvent.js
// module id = 118
// module chunks = 0